import { logError, Logger } from '~/util/logger';

import { Proxy } from '~/models/Contensis';
import ContensisRepository from '~/repositories/ContensisRepository';

class ProxiesService {
  private contensis: ContensisRepository;
  private source: ContensisRepository;
  error: AppError | null = null;
  raw: Proxy[] = [];

  constructor(contensis: ContensisRepository, source: ContensisRepository) {
    this.contensis = contensis;
    this.source = source;
  }

  GetProxies = async (): Promise<[AppError | null, Proxy[]]> => {
    Logger.info(
      `[proxies] ${this.contensis.alias} | Getting proxies in ${this.contensis.projectId}`
    );
    const [err, proxies] = await this.contensis.repo.GetProxies();

    if (err) logError(err);
    else this.raw = proxies?.items || [];

    return [err, this.raw];
  };

  // PublishProxy = async (
  //   proxyId: string
  // ): Promise<[AppError | null, Proxy | undefined]> => {
  //   Logger.info(
  //     `[proxies] ${this.contensis.alias}:${this.contensis.projectId} | Publishing proxy ${proxyId}`
  //   );
  //   const [err, published] = await this.contensis.repo.PublishProxy(proxyId);

  //   if (err) logError(err);
  //   return [err, published];
  // };
}

export default ProxiesService;
